import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isNewAssessment: false,
  };

export const flagSlice = createSlice({
  name: "flag",
  initialState,
  reducers: {
    setIsNewAssessment: (state, { payload }) => {
      state.isNewAssessment = payload;
    },
  },
});

export const { setIsNewAssessment } = flagSlice.actions;

export default flagSlice.reducer;
